import {Component, Input} from '@angular/core'
import {StaticComponentInstance} from '../../static-form/static-form.types'
import {TypedFormGroup} from '../../../../../../core/forms/form-controls.model'
import {LawnMaintenanceStaticJobQuestionsInput, StaticJobQuestionsInput} from '../../../../../../../__generated__/types'
import {FormControl, Validators} from '@angular/forms'

@Component({
  templateUrl: './lawn-maintenance-static-form.component.html',
  styleUrls: ['../../gradual-reveal.css'],
  standalone: false,
})
export class LawnMaintenanceStaticFormComponent implements StaticComponentInstance {
  @Input({required: true}) form!: TypedFormGroup<LawnMaintenanceStaticJobQuestionsInput>

  public static createForm(): TypedFormGroup<LawnMaintenanceStaticJobQuestionsInput> {
    return new TypedFormGroup<LawnMaintenanceStaticJobQuestionsInput>({
      sizeOfArea: new FormControl(0, [Validators.required]),
      shouldBeMowed: new FormControl(false, [Validators.required]),
    })
  }

  questionsInput(): StaticJobQuestionsInput {
    return {
      lawnMaintenance: {
        sizeOfArea: this.form?.value.sizeOfArea || 0,
        shouldBeMowed: this.form?.value.shouldBeMowed || false,
      },
    }
  }
}
